import React from "react";
import { Layout } from 'antd';

const { Footer } = Layout;

const PlatformFooter: React.FC = () => {
  return (
    <Footer className="text-center py-2 platform-footer text-primary text-xs">
      <span className="font-semibold opacity-8">   &#169; 2024 NUNBAA Technologies Private Limited</span>
    </Footer>
  );
};

export default PlatformFooter;
